// Parse hair_static_sidecar.bin.
//
// Layout (must match export_static_hair_assets.py:_write_sidecar):
//   magic       4 bytes  'HRST'
//   version     u32      1
//   P           u32
//   feat_dim    u32
//   reserved    u32
//   roughness   P * f32
//   base_normal P * 3 * f32

const MAGIC = 0x54535248; // 'HRST' little-endian: 0x48 0x52 0x53 0x54

export async function loadSidecar(baseUrl) {
  // cache:'no-store' — large file; avoid Chrome's ERR_CACHE_WRITE_FAILURE (see loadHairPly.js).
  const res = await fetch(`${baseUrl}/hair_static_sidecar.bin`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`fetch sidecar: HTTP ${res.status}`);
  const ab = await res.arrayBuffer();
  return parseSidecar(ab);
}

export function parseSidecar(ab) {
  const dv = new DataView(ab);
  const magic = dv.getUint32(0, true);
  if (magic !== MAGIC) {
    throw new Error(`hair_static_sidecar: bad magic 0x${magic.toString(16)} (expected HRST)`);
  }
  const version = dv.getUint32(4, true);
  if (version !== 1) {
    throw new Error(`hair_static_sidecar: unsupported version ${version}`);
  }
  const P = dv.getUint32(8, true);
  const featDim = dv.getUint32(12, true);
  // reserved = dv.getUint32(16, true);
  const headerLen = 20;
  const roughness = new Float32Array(ab, headerLen, P);
  const baseNormal = new Float32Array(ab, headerLen + P * 4, P * 3);
  // Copy out — these views are tied to the ArrayBuffer; copying lets us
  // free the original buffer if needed and decouples lifetime.
  return {
    P,
    featDim,
    roughness: new Float32Array(roughness),
    baseNormal: new Float32Array(baseNormal),
  };
}
